





























import { Component, Prop, Mixins } from "vue-property-decorator";
import { mapGetters } from "vuex";

// Mixins
import BrandsStore from "@/mixins/brandsStore";

// Enums/Data
import { DataModules } from "@/store/modules/data";

@Component({
  components: {
    "exchange-rates-provider": () =>
      import(
        "@/components/app/admin/settings/currencies/exchangeRatesProvider.vue"
      ),
    "manual-exchange-rates-matrix": () =>
      import(
        "@/components/app/admin/settings/currencies/manualExchangeRatesMatrix.vue"
      )
  },
  computed: {
    ...mapGetters({
      isOrgMode: "brand/isMultibrand"
    })
  }
})
export default class ExchangeRatesComp extends Mixins(BrandsStore) {
  // Getters

  public isOrgMode!: boolean;

  // Refs

  public $refs!: {
    exchangeRatesMatrix: HTMLFormElement;
  };

  // Props

  @Prop({
    required: true,
    validator: tag =>
      ["u-aside", "u-section-box", "u-contextualise"].includes(tag)
  })
  public readonly tag!: "u-aside" | "u-section-box" | "u-contextualise";

  // Methods

  public viewExchangeRateHistory() {
    if (!this.canView) return;

    return this.$store.dispatch(
      `data/${DataModules.MANUAL_EXCHANGE_RATES}/openExchangeRatesListingModal`
    );
  }

  public async save() {
    return this.$refs.exchangeRatesMatrix.save();
  }

  public revertToInitialState() {
    return this.$refs.exchangeRatesMatrix.revertToInitialState();
  }

  // Computed

  public get canView() {
    return this.$userCan("list_manual_exchange_rates");
  }

  public get manualFilters() {
    return { "filter[active]": true };
  }
}
